<template>
  <TabbedPortletOpportunity>
    <TabbedPortletHead>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_SECTION_INTRODUCTION_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_SECTION_INTRODUCTION_TAB)">Introduction</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_SECTION_HOTEL_LIST_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_SECTION_HOTEL_LIST_TAB)">Hotel List</a>
      </li>
      <li class="nav-item">
        <a
          href=""
          class="nav-link"
          :class="{ 'active': selectedTab === tabs.CONSUMER_SECTION_OPTIONAL_EXPERIENCE_TAB }"
          @click.prevent="selectTab(tabs.CONSUMER_SECTION_OPTIONAL_EXPERIENCE_TAB)">Optional Experience</a>
      </li>
    </TabbedPortletHead>

    <TabbedPortletBody>
      <div class="tab-content">
        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_SECTION_INTRODUCTION_TAB">
          <TabIntroduction :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_SECTION_HOTEL_LIST_TAB">
          <TabHotelList :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>

        <TabbedPortletBodyTab :show="selectedTab === tabs.CONSUMER_SECTION_OPTIONAL_EXPERIENCE_TAB" >
          <TabOptionalExperience :validationGroupName="validationGroupName" />
        </TabbedPortletBodyTab>
      </div>
    </TabbedPortletBody>
  </TabbedPortletOpportunity>
</template>

<script>
import TabbedPortletOpportunity from '@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import TabIntroduction from './TabIntroduction.vue'
import TabOptionalExperience from './TabOptionalExperience.vue'
import TabHotelList from './TabHotelList.vue'

export default {
  name: 'TabConsumerSection',
  inject: ['$v'],
  components: {
    TabbedPortletOpportunity,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    TabIntroduction,
    TabOptionalExperience,
    TabHotelList
  },
  data () {
    const CONSUMER_SECTION_INTRODUCTION_TAB = 'consumer-section-introduction-tab'
    const CONSUMER_SECTION_OPTIONAL_EXPERIENCE_TAB = 'consumer-section-optinal-experience-tab'
    const CONSUMER_SECTION_HOTEL_LIST_TAB = 'consumer-section-hotel-list-tab'

    return {
      selectedTab: CONSUMER_SECTION_INTRODUCTION_TAB,
      tabs: {
        CONSUMER_SECTION_INTRODUCTION_TAB,
        CONSUMER_SECTION_OPTIONAL_EXPERIENCE_TAB,
        CONSUMER_SECTION_HOTEL_LIST_TAB
      }
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    isImporting: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    selectTab (tabName) {
      this.selectedTab = tabName
    },
    importInclusions () {
      this.$emit('import')
    }
  }
}
</script>

<style lang="scss" scopep>
</style>
